import { API } from "aws-amplify";

const index = async (management_id, id) => {
  let myInit
  if (id) {
    myInit = {
      // OPTIONAL
      response: true, // OPTIONAL (return the entire Axios response object instead of only response.data)
      queryStringParameters: {
        // OPTIONAL
        management_id: management_id,
        item_id: id
      }
    }
  }
  else {
    myInit = {
      // OPTIONAL
      response: true, // OPTIONAL (return the entire Axios response object instead of only response.data)
      queryStringParameters: {
        // OPTIONAL
        management_id: management_id
      }
    }
  }
  let items = await API.get(
    "InasakuAPI",
    "/inasaku/global-work-histories",
    myInit
  );

  return items;
};

const create = async (management_id, season, item, workItems, imagePaths, accountId, userId, work_history_id) => {
  const paramWorkItems = {};
  for (const e in workItems) {
    if (workItems.hasOwnProperty(e)) {
      paramWorkItems[e] = workItems[e];
    }
  }

  const param = {
    management_id: management_id,
    item_id: item.item_id,
    item_name: item.item_name,
    season_id: season.season_id,
    season_name: season.season_name,
    work_items: workItems,
    image_paths: imagePaths,
  };
  if (work_history_id != null) {
    param.work_history_id = work_history_id;
  }

  let myInit = {
    response: true, // OPTIONAL (return the entire Axios response object instead of only response.data)
    body: {
      data: {
        account_id: accountId,
        user_id: userId,
        work_history: param
      }
    },
    headers: {} // OPTIONAL
  };
  await API.post("InasakuAPI", "/inasaku/global-work-histories", myInit);
};

const update = async (management_id, workHistory, workItems, imagePaths, accountId, userId) => {
  const paramWorkItems = {};
  for (const e in workItems) {
    if (workItems.hasOwnProperty(e)) {
      paramWorkItems[e] = workItems[e];
    }
  }

  let myInit = {
    response: true, // OPTIONAL (return the entire Axios response object instead of only response.data)
    body: {
      data: {
        account_id: accountId,
        user_id: userId,
        work_history: {
          management_id: management_id,
          work_history_id: workHistory.work_history_id,
          item_id: workHistory.item_id,
          item_name: workHistory.item_name,
          season_id: workHistory.season_id,
          season_name: workHistory.season_name,
          work_items: paramWorkItems,
          image_paths: imagePaths,
        }
      }
    },
    headers: {} // OPTIONAL
  };
  let res = await API.put(
    "InasakuAPI",
    `/inasaku/global-work-histories/${workHistory.work_history_id}`,
    myInit
  );

  return res;
};

const del = async (management_id, work_history_id, accountId, userId) => {
  let myInit = {
    response: true, // OPTIONAL (return the entire Axios response object instead of only response.data)
    body: {
      management_id: management_id,
      work_history_id: work_history_id,
      account_id: accountId,
      user_id: userId,
    },
    headers: {} // OPTIONAL
  };
  let res = await API.del(
    "InasakuAPI",
    `/inasaku/global-work-histories/${work_history_id}`,
    myInit
  );

  return res;
};

export default {
  index: index,
  create: create,
  update: update,
  del: del
};
